export const getSavedNavItemPosition = () => {
  const savedNavItemElement = document.getElementById('js-saved-nav-item');
  const position = savedNavItemElement?.getBoundingClientRect();

  return {
    width: position?.width || 0,
    y: position?.y || 0,
  };
};
